import {getUserId} from '../../components/authentication/AuthUtils'
import {
    setStorageAppConfiguration,
    useAppConfiguration,
} from './query-keys/AppQueryManager'

import React, {createContext, useContext, useEffect} from 'react'

const AppContext = createContext({})

const AppProvider = React.memo(({children}) => {
    const {data} = useAppConfiguration(getUserId())

    //#region Preload Images
    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            setStorageAppConfiguration(data)
        }

        if (data?.hospitalsBelong?.length > 0) {
            data.hospitalsBelong.map(hospitalItem => {
                if (!!hospitalItem?.logo) {
                    const img = new Image()
                    img.src = hospitalItem.logo
                }

                return null
            })
        }
    }, [data])
    //#endregion

    return (
        <AppContext.Provider
            value={{
                userRole: data?.userRole,

                timezoneId: data?.timezoneId,

                hospitalsBelong: data?.hospitalsBelong,

                widget: data?.widget,
                menuItems: data?.menuItems,

                notificationSetting: data?.notificationSetting,
                viewOptions: data?.viewOptions,
                languages: data?.languages,
            }}>
            {children}
        </AppContext.Provider>
    )
})

export const useAppConfig = () => useContext(AppContext)

export default AppProvider
